import React, { useEffect, useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import TagService from "../../../services/TagService";
import LicenseService from "../../../services/LicensesService";
import { useTranslation } from "react-i18next";
import { formatMoney } from "../../../utils/number";
import { Copy } from "../../../components/Copy/Copy";
import { BillingPeriod } from "../../../constants/billing";

const ListLicenseTypes = (props) => {
   const [types, setTypes] = useState([]);
   const [maxPage, setMaxPage] = useState(1);
   const [currentPage, setCurrentPage] = useState(1);
   const { user } = useAuth();
   const [collumnClicked, setCollumnClicked] = useState({
      collumnTitle: "level",
      orderDirection: "ASC",
   });
   const [isLoading, setIsLoading] = useState(true);
   const { t } = useTranslation();

   const getLicenseTypes = async (page, searchText, collumnClicked) => {
      setIsLoading(true);
      const response =
         await LicenseService.getPaginatedTypes(
            page,
            searchText,
            collumnClicked,
            true
         );
      setTypes(response.data.items);
      setMaxPage(response.data.pagination.totalPages);
      setIsLoading(false);
   };

   useEffect(() => {
      getLicenseTypes(currentPage, props.filters, collumnClicked);
   }, [
      user,
      currentPage,
      props.filters,
      collumnClicked,
      props.refreshKey
   ]);

   return (
      <>
         <div className="list-container list-visibility">
            <List
               isLoading={isLoading}
               handleCollumnTitleClick={(collumnIndex) =>
                  setCollumnClicked(collumnIndex)
               }
               collumsObjIndex={[
                  { collumnLabel: t("common.name"), index: "name", type: "text" },
                  {
                     collumnLabel: "Código",
                     index: "code",
                     type: "custom",
                     custom: ({ row }) => {
                        return (
                           <Copy text={row.code} showText={true} onClick={(e) => e.stopPropagation()} />
                        );
                     }
                  },
                  {
                     collumnLabel: "Valor mensal",
                     type: "custom",
                     custom: ({ row }) => {
                        const price = row.currentPrices?.[BillingPeriod.MONTHLY];
                        if (!price) {
                           return <span className="opacity-40">Não consta</span>
                        }
                        return <b className="font-semibold!">R$ {formatMoney(price.amount)}</b>
                     }
                  },
                  {
                     collumnLabel: "Valor anual",
                     type: "custom",
                     custom: ({ row }) => {
                        const price = row.currentPrices?.[BillingPeriod.MONTHLY];
                        const priceYearly = row.currentPrices?.[BillingPeriod.YEARLY];
                        return (
                           <div>
                              {priceYearly ? (
                                 <>
                                    <b className="font-semibold!">R$ {formatMoney(priceYearly.amount)}</b>
                                    {price.amount != null && price.amount > (priceYearly.amount / 12) && (
                                       <span className="inline-flex font-semibold! ml-1! text-red-400">(-{((1 - (priceYearly.amount / 12) / price.amount) * 100).toFixed(1)}%)</span>
                                    )}
                                 </>
                              ) : (
                                 <span className="opacity-40">Não consta</span>
                              )}
                           </div>
                        );
                     }
                  },
                  {
                     collumnLabel: t("common.enabled"),
                     index: "enabled",
                     type: "enabled",
                  },
               ]}
               data={types}
            />
         </div>
         <div className="card-visibility">
            {types &&
               types.map((type, index) => (
                  <Card
                     key={index}
                     data={type}
                     image={profileAvatar}
                     delete={() => LicenseService.deleteType(type.id)}
                     navigateOnDelete={"/licenses/types"}
                     navigateOnEdit={"/licenses/types"}
                     askForPasswordOnDelete={true}
                  >
                     <p className="card-content-title">{type.name}</p>
                  </Card>
               ))}
         </div>
         <Pagination
            rowsPerPage={50}
            maxPage={maxPage}
            changePage={(page) =>
               setCurrentPage(page)
            }
         />
      </>
   );
};

export default ListLicenseTypes;